import { CheckCircle } from '@phosphor-icons/react'
import React from 'react'

const ApplicationSubmitted = () => {
    return (
        <div className="h-screen bg-[#F7F7F7] p-6">
            <div className="h-full flex items-center justify-center">
                <div className="w-full max-w-2xl bg-white rounded-xl shadow-sm px-6 py-10 md:px-10 md:py-14">
                    <div className="mx-auto flex flex-col items-center gap-8 text-center">

                        <img
                            src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/images/common/application-submitted.png"
                            alt="Application submitted"
                            className="w-80 md:w-96"
                        />

                        <div className="flex flex-col gap-3">
                            <h2 className="text-xl md:text-2xl font-semibold text-gray-900">
                                Application submitted successfully
                            </h2>

                            <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
                                Your application has been received and is now being processed.
                                You don’t need to take any action at the moment.
                            </p>
                        </div>

                        <div className="w-full max-w-xs h-px bg-gray-200" />

                        <div className="flex flex-col gap-3 text-gray-700">
                            <div className="flex items-center justify-center gap-3">
                                <CheckCircle size={20} className="text-green-600" />
                                <span className="text-sm md:text-base">
                                    We’ll notify you once there’s an update on your visa
                                </span>
                            </div>
                        </div>

                        <p className="text-xs text-gray-500">
                            Processing timelines may vary depending on the embassy and visa type.
                        </p>

                    </div>
                </div>
            </div>
        </div>

    )
}

export default ApplicationSubmitted